import { Injectable } from '@angular/core';
import { LStep } from 'core/dto';
import { BehaviorSubject, map, Subject } from 'rxjs';


@Injectable()
export class ProcessStepperService {


  readonly stepArray: LStep[] = ['documentUpload', 'selectSigners', 'setSignatures', 'review'];
  readonly currentStepSubject = new BehaviorSubject<LStep>('documentUpload');

  readonly stepIdxObs = this.currentStepSubject.pipe(map((currentStep) => this.stepArray.indexOf(currentStep)));
  readonly triedNextSubject = new BehaviorSubject<{ [step in LStep]?: boolean }>({})

  readonly stepChangedSubject = new Subject<{ from: LStep, to: LStep }>()

  constructor() {

  }

  nextStep() {

    const currentStep = this.currentStepSubject.value;
    const stepIdx = this.stepArray.indexOf(currentStep);

    if (stepIdx >= this.stepArray.length - 1) {
      return;
    }

    const nextStep = this.stepArray[stepIdx + 1]
    this.currentStepSubject.next(nextStep)

    this.stepChangedSubject.next({ from: currentStep, to: nextStep });
  }

  prevStep() {

    const currentStep = this.currentStepSubject.value;
    const stepIdx = this.stepArray.indexOf(currentStep);

    if (stepIdx <= 0) {
      return;
    }

    const nextStep = this.stepArray[stepIdx - 1]
    this.currentStepSubject.next(nextStep);
    this.stepChangedSubject.next({ from: currentStep, to: nextStep });

  }

  selectStep(stepIdx: number) {
    this.currentStepSubject.next(this.stepArray[stepIdx])
  }

  ngOnDestroy() {

    this.currentStepSubject.complete();
    this.triedNextSubject.complete();
    this.stepChangedSubject.complete();
  }

}
